import { ListItemAvatar, ListItemText, MenuItem } from '@material-ui/core'
import { ArrowRightAltOutlined } from '@material-ui/icons'
import { useBomItemDetails } from 'features/BillOfMaterials/components/useBomItemDetails'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { BoMItemType } from 'model/Project/BoMItemRow'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { useBomItemMenuStyles } from './BomItemMenuItem'

export const OpenDetailsSidePanelButton = (props: {
  bomItemId: string
  bomItemType: BoMItemType
  onClose: () => void
}) => {
  const { handleOpenBomItemDetails } = useBomItemDetails()
  const { t } = useTranslation()
  const classes = useBomItemMenuStyles()
  const isBuyerView = useAppSelector(
    projectSelectors.ProjectInBuyerViewSelector
  )

  if (isBuyerView) {
    return null
  }

  return (
    <span>
      <MenuItem
        onClick={() => {
          handleOpenBomItemDetails(props.bomItemId, props.bomItemType, true)
          props.onClose()
        }}
        className={classes.menuRoot}
      >
        <ListItemAvatar className={classes.menuItemAvatar}>
          <ArrowRightAltOutlined />
        </ListItemAvatar>
        <ListItemText
          primary={t('project:open-bom-item-details-title', 'details')}
          secondary={t(
            'project:open-bom-item-details',
            'open in details panel'
          )}
        />
      </MenuItem>
    </span>
  )
}
